import React, { Component } from "react"
import "./Leadpage.scss"
import { push } from "../Services/Analytics";
import ScrollableAnchor from "react-scrollable-anchor";

class Leadpage extends Component {
    sendToLeadpage()    {
        window.open("https://z.ynet.co.il/mlong/commerce/2018/bringbringlead/", "_blank");
        push("Button_Clicked", "Redirect to Lead Page");
    }
    render() {
        return (
            <ScrollableAnchor id="lead">
            <section className="section section-leadpage">
                <div className="padding">
                    <div className="container">
                        <div className="imagehead"></div>
                        <div className="headline">
                            שחקני נשמה
                        </div>
                        <div className="separator"></div>
                        <div className="desc">
                            <span>
                                עמדתם שעתיים מול חלון ראווה של חנות טלוויזיות?
                        <span className="brdesktop"><br /></span> התנחלתם באיזה קפה אינטרנט דלוח בהודו?</span>
                            <br />
                            ספרו לנו על הדברים המטורפים והקיצוניים ביותר שעשיתם בשביל לצפות במשחק מהמונדיאל, ואנחנו נבחר את הכי מקוריים ונפנק אותם ב-300 ₪ לקניות באתר <strong>BringBring סופרמרקט אונליין</strong>.
                                <div className="footer" onClick={this.sendToLeadpage}>
                                <div className="sendbutton">
                                    לחצו כאן כדי לספר לנו
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            </ScrollableAnchor>
        )
    }
}

export default Leadpage;


// WEBPACK FOOTER //
// ./src/Components/Leadpage/Leadpage.jsx